export default "__VITE_ASSET__ec6aacbb__"